<script>
  import { onMount, createEventDispatcher } from 'svelte'

  import dayjs from 'dayjs'

  import approxNowStore from '../../stores/approx-now.js'
  import userStore from '../../stores/user.js'

  import AlertPermissionDialog from './alert-permission-dialog.svelte'
  import DialogMenu from './dialog-menu.svelte'


  export let alertDt = null
  export let unsaved = false

  let showAlertPermissionDialog = false

  let showAlertDialog = false
  const alertDialogItems = [
    {type: 'button', text: '1 hour', func: () => alert(1, 'hour')},
    {type: 'button', text: '6 hours', func: () => alert(6, 'hours')},
    {type: 'button', text: '12 hours', func: () => alert(12, 'hours')},
    {type: 'button', text: '24 hours', func: () => alert(24, 'hours')},
    {type: 'button', text: '7 days', func: () => alert(7, 'days')},
  ]
  const openAlertDialog = function () {
    if ($userStore.alertsEnabled) {
      showAlertDialog = true
    } else {
      showAlertPermissionDialog = true
    }
  }

  const dispatch = createEventDispatcher()

  const alert = function (length, unit) {
    dispatch('alert', {alertDt: dayjs().add(length, unit).format()})
  }

  const unAlert = function () {
    dispatch('unAlert')
  }

  onMount(() => {
    userStore.maybeInit()
  })
</script>

{#if $userStore}
  {#if $userStore.alertsEnabled && alertDt && dayjs(alertDt) > $approxNowStore}
    <button class="iconButton" on:click={unAlert} title="Remove Alert">
      <svg class="icon" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9">
        </path>
      </svg>
    </button>
  {:else}
    <button class="iconButton" on:click={openAlertDialog} title="Set Alert">
      <svg class="icon" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9">
        </path>
      </svg>
    </button>
  {/if}
{/if}

<DialogMenu bind:show={showAlertDialog} header="Alert In" menuItems={alertDialogItems} />
<AlertPermissionDialog {unsaved} bind:show={showAlertPermissionDialog} />
